var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWorkflowEdit = function SvgIconWorkflowEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "M16.555 2.293a1 1 0 0 0-1.415 0L4.792 12.653a1 1 0 0 0-.292.707V17a1 1 0 0 0 1 1h3.659a1 1 0 0 0 .707-.293L20.207 7.361a1 1 0 0 0 0-1.414zM6.5 13.773l9.348-9.358 2.238 2.239L8.744 16H6.5v-2.226ZM3.5 20a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2z",
    "data-follow-fill": "currentColor"
  })));
};
export default SvgIconWorkflowEdit;